import { documentReady, checkCookie } from "../Utility/utils";
const body = document.body;
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
const scrollAmount = 400;
let lastScroll = 0;

// show/hide header on scroll
window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 0) {
    body.classList.remove(scrollUp);
    return;
  }
  if (currentScroll > scrollAmount && currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
  } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});

documentReady((event) => {
  const initNotificationBar = () => {
    const notificationBar = document.querySelector(".header-notification-bar");
    if (notificationBar) {

      // Check if the notification bar should be displayed
      const notificationBarClosed = checkCookie("notificationBarClosed");
      if (!notificationBarClosed) {
        notificationBar.style.display = "block";
        notificationBar.setAttribute("aria-hidden", "false");
      } else {
        notificationBar.remove();
        return;
      }
      
      // Set css custom property for element height on the body
      const setHeightCSSProperty = () => {
        const notificationHeight = notificationBar.offsetHeight;
        body.style.setProperty("--notification-bar-height", `${notificationHeight}px`);
      };
      setHeightCSSProperty();
     
      window.addEventListener("resize", () => {
        setHeightCSSProperty();
      });

      // Set up close button
      const closeButton = notificationBar.querySelector(".header-notification-close");
      if(closeButton){
        closeButton.addEventListener("click", () => {
          notificationBar.style.display = "none";
          body.style.setProperty("--notification-bar-height", "0px");
          document.cookie = "notificationBarClosed=true; path=/";
        });
      }
    }
  }
  initNotificationBar();
});